import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import { Tooltipped } from 'react-md';

import CustomMenuIcon from '../CustomMenuIcon';

import './ExtraMenuBlock.scss';

const ExtraMenuBlock = ({ extraMenu }) => (
  <div className="external-nav-items" key="external-nav-items">
    {extraMenu.map(extra => (
      <Tooltipped
        key={`external-nav-item-tooltip-${get(extra, 'label')}`}
        className="external-nav-item-tooltip"
        label={get(extra, 'label')}
        position="right"
      >
        <a
          className="external-nav-item"
          href={get(extra, 'url')}
          key={`external-nav-item-${get(extra, 'label')}`}
        >
          <CustomMenuIcon name={get(extra, 'icon')} alt={get(extra, 'label')} />
          <div className="nav-link md-tile-text--primary">{get(extra, 'label')}</div>
        </a>
      </Tooltipped>
    ))}
  </div>
);

ExtraMenuBlock.propTypes = {
  extraMenu: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      action: PropTypes.oneOf(['link', 'callback']),
      label: PropTypes.string,
      icon: PropTypes.string
    })
  )
};

ExtraMenuBlock.defaultProps = {
  extraMenu: []
};

export default ExtraMenuBlock;
